var map = {
	"./card_1.mp3": 84052,
	"./chat_1.mp3": 8024,
	"./error_1.mp3": 79360,
	"./game_over_1.mp3": 88181,
	"./game_over_2.mp3": 51554,
	"./heart_1.mp3": 41418,
	"./notify_1.mp3": 82701,
	"./notify_2.mp3": 63450,
	"./shuffle_1.mp3": 18201,
	"./winner_1.mp3": 93887,
	"./winner_2.mp3": 1160,
	"./winner_3.mp3": 46445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91159;